import {
  Languages, Monitor, MessageSquareText, Globe2, Calculator, Landmark,
  BookOpen, Leaf, Atom, ScrollText, FlaskConical, Scale,
} from "lucide-react";

export const GRADES = [7, 8, 9, 10, 11, 12];

export const SUBJECTS = [
  { id: "kazakh", name: "Казахский язык", icon: Languages },
  { id: "informatics", name: "Информатика", icon: Monitor },
  { id: "english", name: "Английский язык", icon: MessageSquareText },
  { id: "geography", name: "География", icon: Globe2 },
  { id: "math", name: "Математика", icon: Calculator },
  { id: "kz_history", name: "История Казахстана", icon: Landmark },
  { id: "russian", name: "Русский язык", icon: BookOpen },
  { id: "biology", name: "Биология", icon: Leaf },
  { id: "physics", name: "Физика", icon: Atom },
  { id: "world_history", name: "Всемирная история", icon: ScrollText },
  { id: "chemistry", name: "Химия", icon: FlaskConical },
  { id: "law", name: "Основы права", icon: Scale },
];

export function channelsFor(user) {
  const staff = user.role === "admin" || user.role === "moderator";
  const grades = staff ? GRADES : [user.grade].filter(Boolean);
  return [
    { id: "general", name: "Общий чат", group: "Общее" },
    ...grades.map((g) => ({ id: `grade-${g}`, name: `${g} класс`, group: "Классы" })),
    ...SUBJECTS.map((s) => ({ id: `subj-${s.id}`, name: s.name, group: "Предметы" })),
  ];
}

export const channelName = (id) => {
  if (!id || id === "general") return "Общий чат";
  if (id.startsWith("grade-")) return `${id.slice(6)} класс`;
  return SUBJECTS.find((s) => `subj-${s.id}` === id)?.name || id;
};

export const PLAN_NAMES = { free: "Free", basic: "Basic", pro: "Pro" };
const CUR = { KZT: "₸", RUB: "₽", USD: "$", EUR: "€" };
export const formatMoney = (n, c) => `${Number(n).toLocaleString("ru-RU")} ${CUR[c] || c}`;

export const subjectById = (id) => SUBJECTS.find((s) => s.id === id);

export const KINDS = [
  { id: "SOR", name: "СОР" },
  { id: "SOCH", name: "СОЧ" },
  { id: "OTHER", name: "Другое" },
];
export const kindName = (id) => KINDS.find((k) => k.id === id)?.name || id;

export const ALLOWED_EXT = ["jpg", "jpeg", "png", "gif", "webp", "heic", "bmp", "doc", "docx", "ppt", "pptx", "pdf", "txt"];
export const ACCEPT = ALLOWED_EXT.map((e) => `.${e}`).join(",");
export const MAX_SIZE = 20 * 1024 * 1024;

export const ROLE_NAMES = { admin: "Админ", moderator: "Модератор", user: "Ученик" };
export const coinLabel = (u) => (u.role === "admin" ? "∞" : u.coins);
export const formatDay = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("ru-RU", { day: "numeric", month: "long", year: "numeric" });

export const materialsWord = (n) => {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return `${n} материал`;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return `${n} материала`;
  return `${n} материалов`;
};

export const formatSize = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} МБ` : `${Math.max(1, Math.round(b / 1024))} КБ`);
export const formatDate = (s) => new Date(s).toLocaleString("ru-RU", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
